
export default function InfoButton(props) {
    return (
        <span className="text-xs bg-gray-200 py-1 px-2 rounded-md min-w-fit">{props.info}</span>
    )
}
